<template>
  <div class="px-4">
    <reservation-services
      :services="reservation.services"
      :reservation="reservation"
    />
  </div>
</template>

<script setup lang="ts">
import ReservationServices from '@/components/reservation/elements/Services.vue'

interface Props {
  reservation?: object | null
}

withDefaults(defineProps<Props>(), {
  reservation: null,
})
</script>
